import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "n-icon-star",
  "use": "n-icon-star-usage",
  "viewBox": "0 0 6 6",
  "content": "<symbol viewBox=\"0 0 6 6\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"n-icon-star\">\n<path d=\"M0 1.82833L2.3154 2.99742L0 4.16652L0.395176 4.8309L2.67161 3.5382L2.60482 6H3.39518L3.32839 3.5382L5.60482 4.8309L6 4.16652L3.67904 2.99742L6 1.82833L5.60482 1.16395L3.32839 2.45665L3.39518 0H2.60482L2.67161 2.4618L0.395176 1.16395L0 1.82833Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol